/*eslint-disable */
import { Box, Skeleton, styled } from "@mui/material";

const SkeletonWrapper = styled(Box)(({ theme }) => ({
  border: "1px solid" + theme.palette.primary.main,
  borderRadius: "10px",
  marginBottom: "15px",
  padding: "22px 18px 14px",
  "&.headingContent": {
    border: "none",
  },
}));
const DraggableItemsLoader = ({ Topic, TopicTwo, Content, HeadingContent }) => {
  return (
    <SkeletonWrapper className={`${HeadingContent && "headingContent"}`}>
      {Topic && <Skeleton width="100%" animation="pulse" sx={{ marginBottom: "5px" }} />}
      {TopicTwo && <Skeleton width="60%" animation="pulse" sx={{ marginBottom: "5px" }} />}
      {Content && (
        <>
          <Skeleton width="100%" height="15px" animation="pulse" sx={{ marginBottom: "2px" }} />
          <Skeleton width="100%" height="15px" animation="pulse" sx={{ marginBottom: "2px" }} />
          <Skeleton width="100%" height="15px" animation="pulse" sx={{ marginBottom: "2px" }} />
          <Skeleton width="80%" height="15px" animation="pulse" sx={{ marginBottom: "2px" }} />
        </>
      )}
      {HeadingContent && (
        <Skeleton variant="rectangular" width="100%">
          <Box sx={{ paddingTop: "57%" }}></Box>
        </Skeleton>
      )}
    </SkeletonWrapper>
  );
};

export default DraggableItemsLoader;
